import Image, { type ImageProps } from 'next/image';

import type { TUIResourceId, TUIResourceImage } from '@/ducks/common/resources';

import { useUIResource } from '@/ducks/common/resources';

type TProps = {
  resourceId: TUIResourceId;
} & Partial<ImageProps>;

const UIResourceImage = ({ resourceId, ...restProps }: TProps) => {
  const { alt, src } = useUIResource<TUIResourceImage>(resourceId) || {};
  const { fill, height, width } = restProps || {};
  const Node = fill || (width && +width > 0 && height && +height > 0) ? Image : 'img';
  return <Node {...restProps} alt={restProps.role === 'presentation' ? '' : alt} src={src} />;
};

export default UIResourceImage;
